/** Barramento leve para feedback Office (substitui toasts Sonner). */

const listeners = new Set();

export function subscribeOfficeNotify(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function emitOfficeNotify(payload) {
  listeners.forEach((fn) => {
    try {
      fn(payload);
    } catch {
      /* ignore */
    }
  });
}

export function dismissOfficeNotify(id) {
  if (id == null || id === '') return;
  emitOfficeNotify({ type: 'dismiss', id: String(id) });
}
